<template>
    <a-modal :width="750" :open="open" :style="isMobile ? modalMobileStyleObject : ''" @cancel="closeForm" :footer="null" class="modal-no-padding">
      <div class="modal-no-padding__header">
        <h2>Управление доступами</h2>
      </div>
      <a-divider style="margin: 16px 0"/>
      <div class="main-body">
        <div class="modal-no-padding__body">
          <div class="border-block group-block">
            <template v-if="mode === 'staff'">
          <span class="semi-bold" v-if="name && userData.length === 1">
              Пользователь
          </span>
              <span class="semi-bold" v-else>
              Пользователи
            </span>
            </template>
            <template v-else>
           <span class="semi-bold" v-if="name && userData.length === 1">
              Группа
          </span>
              <span class="semi-bold" v-else>
              Группы
        </span>
            </template>
            &ndash;
            <span v-if="!name && !userData.length" class="semi-bold link" @click="() => showProductUsers('empty')">
            Все сотрудники
          </span>
            <span v-else class="semi-bold link" @click="() => showProductUsers('all')">
            {{ name ?? (userData.length + ' ' + getWordFormBasedOnTheCount(userData.length, 'сотрудник', 'сотрудника', 'сотрудников'))}}
          </span>
          </div>

          <div class="border-block access-switch-block">
            <div class="access-switch">
              <a-switch v-model:checked="sendInvite" />
              <span>Отправлять приглашение на почту</span>
            </div>

            <div class="access-switch">
              <a-switch v-model:checked="allowViewReport" />
              <span>Выдать отчет после прохождения тестирования</span>
            </div>
          </div>

          <a-collapse
              v-model:model="showInstruction"
              expandIconPosition="end"
              :bordered="false"
              style="font-weight: 600"
          >
            <template #expandIcon="{ isActive }">
              <UpOutlined v-if="isActive" />
              <DownOutlined v-else />
            </template>

            <a-collapse-panel key="1" header="Как работать с доступами?" style="width: 100%; font-weight: 400; padding: 16px">
              <div class="alert-block">
                <p>
                  <span class="semi-bold">Доступно</span> &ndash; доступы, готовые к выдаче в компании.
                </p>

                <p>
                  <span class="semi-bold">Выдано</span> &ndash; доступы, которые уже назначены на сотрудников этой группы.
                </p>

                <p>
                  <span class="semi-bold">К выдаче</span> &ndash; сколько спишется с баланса. Система учитывает тех, у кого доступ уже есть, поэтому начисляет только недостающие.
                </p>
              </div>

              <div class="alert-block">
                <span class="semi-bold">Управление:</span>
                <ul>
                  <li>
                    Кнопки <i>Выдать/Отозвать</i> применяются массово ко всем сотрудникам группы.
                  </li>
                  <li>
                    При нажатии кнопка становится залитой (цветной), а цифры в таблице автоматически пересчитываются, показывая будущий результат.
                  </li>
                  <li>
                    При нехватке доступов нажмите <i>Заказать доступы</i> &ndash; необходимое количество посчитается автоматически.
                  </li>
                </ul>
              </div>

              <div class="alert-block">
                <span class="semi-bold">Если кнопка неактивна (серая):</span>
                <ul>
                  <li>
                    Для кнопки <i>Выдать</i>: пользователю уже выдан соответствующий продукт или недостаточно доступов. Нажмите <i>Заказать доступы</i> для пополнения.
                  </li>
                  <li>
                    Для кнопки <i>Отозвать</i>: сотрудник уже начал прохождение теста или курса, либо ничего не назначено.
                  </li>
                </ul>
              </div>

              <div class="alert-block">
                <p>
                  Все изменения будут сохранены только после нажатия кнопки <i>Применить</i>
                </p>
              </div>

              <a-alert show-icon message="Если сотрудник уже начал тест или курс, отозвать доступ нельзя." type="info" class="blue-alert">
                <template #icon>
                  <InfoCircleFilled style="color: var(--main-blue)"/>
                </template>
              </a-alert>
            </a-collapse-panel>
          </a-collapse>

          <div v-if="quotasLoaded">
            <div v-if="!isMobile" class="table-block">
              <a-table
                  :columns="getExtendedColumns('tests', 'Оценка ЭИ')"
                  rowKey="id" :data-source="tableData.tests"
                  :scroll="{ x: 660 }"
                  :components="getTableComponents('tests')"
                  :pagination="false"
                  :locale="{ emptyText: emptySlot()}"
                  :table-layout="'fixed'"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'control'">
                    <div class="control-button-wrapper">

                      <template v-if="!recentlyFinishedTests[record.product_id] || !recentlyFinishedTests[record.product_id].length || formData.tests_to_add.includes(record.product_id) || parseInt(record.free) < record.to_append">
                        <a-button class="control-button"
                                  :disabled="(parseInt(record.free) < record.to_append && insufficientProducts.tests.some((el) => el.product_id === record.product_id)) || !record.to_append"
                                  @click="() => handleQuota('tests', record, 'add')"
                                  :class="[{'selected': formData.tests_to_add.includes(record.product_id)}]"
                        >
                          Выдать
                        </a-button>
                      </template>

                      <template v-else>
                        <a-popconfirm
                            :open="openRowKey === (record.product_id + '_add')"
                            placement="top"
                            :show-cancel="true"
                            :icon="null"
                            ok-text="Выдать"
                            cancel-text="Не выдавать"
                            overlay-class-name="revoke-popconfirm"
                            @confirm="() => handleQuota('tests', record, 'add')"
                        >

                          <template #title>
                            <div class="pc-head">
                              <ExclamationCircleOutlined class="pc-warn-ic" />
                              <div class="pc-text">
                                <div class="pc-title">
                              <span class="link" @click="() => showProductUsers(record.product_id, 'tests', 'recently_finished')">
                                {{ (recentlyFinishedTests[record.product_id].length + ' ' + getWordFormBasedOnTheCount(recentlyFinishedTests[record.product_id].length, 'сотрудник', 'сотрудника', 'сотрудников')) }}
                              </span>
                                </div>
                                <div class="pc-sub">
                                  {{ 'недавно ' +
                                getWordFormBasedOnTheCount(recentlyFinishedTests[record.product_id].length, 'прошел', 'прошли', 'прошли') + ' тестирование'}}
                                </div>
                              </div>
                            </div>
                          </template>

                          <template #description>
                            <div class="pc-desc">
                              Мы рекомендуем проходить его не чаще одного раза в полгода, на развитие способностей ЭИ требуется время.
                            </div>
                          </template>

                          <template #cancelButton>
                            <a-button class="secondary-button" @click="openRowKey = null">
                              Не выдавать
                            </a-button>
                          </template>

                          <template #okButton>
                            <a-button class="create-button"
                                      @click="() => handleQuota('tests', record, 'add')"
                            >
                              Выдать
                            </a-button>
                          </template>

                          <a-button :disabled="!record.to_append" class="control-button"  @click="() => {if (!formData.tests_to_add.includes(record.product_id)) handlePopup(record.product_id, 'add')}"
                                    :class="[{'selected': formData.tests_to_add.includes(record.product_id)}]"
                          >
                            Выдать
                          </a-button>
                        </a-popconfirm>
                      </template>

                      <template v-if="record.to_remove === record.issued || formData.tests_to_remove.includes(record.product_id)">
                        <a-button class="control-button" :disabled="!record.to_remove"  @click="() => handleQuota('tests', record, 'remove')" :class="[{'selected': formData.tests_to_remove.includes(record.product_id)}]">
                          Отозвать
                        </a-button>
                      </template>

                      <template v-else>
                        <a-popconfirm
                            :open="openRowKey === (record.product_id + '_remove')"
                            placement="top"
                            :show-cancel="true"
                            :icon="null"
                            ok-text="Отозвать"
                            cancel-text="Отменить"
                            overlay-class-name="revoke-popconfirm"
                            @confirm="() => handleQuota('tests', record, 'remove')"
                        >

                          <template #title>
                            <div class="pc-head">
                              <ExclamationCircleOutlined class="pc-warn-ic" />
                              <div class="pc-text">
                                <div class="pc-title">Доступ отзовется</div>
                                <div class="pc-sub">
                              <span class="link" @click="() => showProductUsers(record.product_id, 'tests', 'remove')">
                                {{ buildMessageString('tests', record.product_id, ['сотрудника', 'сотрудников', 'сотрудников']) }}
                              </span>
                                </div>
                              </div>
                            </div>
                          </template>

                          <template #description>
                            <div class="pc-desc">
                              Некоторые сотрудники уже начали тестирование, поэтому у них нельзя отозвать доступ.
                            </div>
                          </template>

                          <template #cancelButton>
                            <a-button class="secondary-button" @click="openRowKey = null">
                              Отменить
                            </a-button>
                          </template>

                          <template #okButton>
                            <a-button class="primary-button"
                                      @click="() => handleQuota('tests', record, 'remove')"
                            >
                              Отозвать
                            </a-button>
                          </template>

                          <a-button :disabled="!record.to_remove" class="control-button"  @click="() => {if (!formData.tests_to_remove.includes(record.product_id)) handlePopup(record.product_id, 'remove')}"
                                    :class="[{'selected': formData.tests_to_remove.includes(record.product_id)}]"
                          >
                            Отозвать
                          </a-button>
                        </a-popconfirm>
                      </template>
                    </div>
                  </template>

                  <template v-if="column.dataIndex === 'to_append'">
              <span :class="[{'error': parseInt(record.free) < record.to_append && !formData.tests_to_add.includes(record.product_id), 'semi-bold': true }]">
                {{ text }}
              </span>
                  </template>

                  <template v-else-if="['free', 'issued'].includes(column.dataIndex)">
              <span class="semi-bold">
                {{ text }}
              </span>
                  </template>

                </template>
              </a-table>

              <a-table
                  :columns="getExtendedColumns('courses', 'Развитие (курсы, практикумы, тренажеры)')"
                  rowKey="id" :data-source="tableData.courses"
                  :scroll="{ x: 660 }"
                  :components="getTableComponents('courses')"
                  :pagination="false"
                  :locale="{ emptyText: emptySlot()}"
                  :table-layout="'fixed'"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'control'">
                    <div class="control-button-wrapper">
                      <a-button
                          :disabled="(parseInt(record.free) < record.to_append && insufficientProducts.courses.some((el) => el.product_id === record.product_id)) || !record.to_append"
                          class="control-button" @click="() => handleQuota('courses', record, 'add')"
                          :class="[{'selected': formData.courses_to_add.includes(record.product_id)}]"
                      >
                        Выдать
                      </a-button>

                      <template v-if="record.to_remove === record.issued || formData.courses_to_remove.includes(record.product_id)">
                        <a-button :disabled="!record.to_remove" class="control-button"  @click="() => handleQuota('courses', record, 'remove')"
                                  :class="[{'selected': formData.courses_to_remove.includes(record.product_id)}]"
                        >
                          Отозвать
                        </a-button>
                      </template>

                      <template v-else>
                        <a-popconfirm
                            :open="openRowKey === (record.product_id + '_remove')"
                            placement="top"
                            :show-cancel="true"
                            :icon="null"
                            ok-text="Отозвать"
                            cancel-text="Отменить"
                            overlay-class-name="revoke-popconfirm"
                            @confirm="() => handleQuota('courses', record, 'remove')"
                        >

                          <template #title>
                            <div class="pc-head">
                              <ExclamationCircleOutlined class="pc-warn-ic" />
                              <div class="pc-text">
                                <div class="pc-title">Доступ отзовется</div>
                                <div class="pc-sub">
                              <span class="link" @click="() => showProductUsers(record.product_id, 'courses', 'remove')">
                                {{ buildMessageString('courses', record.product_id, ['сотрудника', 'сотрудников', 'сотрудников']) }}
                            </span>
                                </div>
                              </div>
                            </div>
                          </template>

                          <template #description>
                            <div class="pc-desc">
                              Некоторые сотрудники уже начали курсы, поэтому у них нельзя отозвать доступ.
                            </div>
                          </template>

                          <template #cancelButton>
                            <a-button class="secondary-button" @click="openRowKey = null">
                              Отменить
                            </a-button>
                          </template>

                          <template #okButton>
                            <a-button class="create-button"
                                      @click="() => handleQuota('courses', record, 'remove')"
                            >
                              Отозвать
                            </a-button>
                          </template>

                          <a-button :disabled="!record.to_remove" class="control-button"  @click="() => {if (!formData.courses_to_remove.includes(record.product_id)) handlePopup(record.product_id, 'remove')}"
                                    :class="[{'selected': formData.courses_to_remove.includes(record.product_id)}]"
                          >
                            Отозвать
                          </a-button>
                        </a-popconfirm>
                      </template>
                    </div>
                  </template>

                  <template v-if="column.dataIndex === 'to_append'">
              <span :class="[{'error': parseInt(record.free) < record.to_append && !formData.courses_to_add.includes(record.product_id), 'semi-bold': true}]">
                {{ text }}
              </span>
                  </template>

                  <template v-else-if="['free', 'issued'].includes(column.dataIndex)">
              <span class="semi-bold">
                {{ text }}
              </span>
                  </template>
                </template>
              </a-table>

              <a-table
                  v-if="tableData.tools"
                  :columns="getExtendedColumns('tools', 'Ежедневные помощники')"
                  rowKey="id" :data-source="tableData.tools"
                  :scroll="{ x: 660 }"
                  :components="getTableComponents('tools')"
                  :pagination="false"
                  :locale="{ emptyText: emptySlot()}"
                  :table-layout="'fixed'"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'control'">
                    <div class="control-button-wrapper">
                      <a-button
                          :disabled="(parseInt(record.free) < record.to_append && insufficientProducts.courses.some((el) => el.product_id === record.product_id)) || !record.to_append"
                          class="control-button" @click="() => handleQuota('tools', record, 'add')"
                          :class="[{'selected': formData.tools_to_add.includes(record.product_id)}]"
                      >
                        Выдать
                      </a-button>

                      <a-button :disabled="!record.to_remove" class="control-button"  @click="() => handleQuota('tools', record, 'remove')"
                                :class="[{'selected': formData.tools_to_remove.includes(record.product_id)}]"
                      >
                        Отозвать
                      </a-button>
                    </div>
                  </template>

                  <template v-if="column.dataIndex === 'to_append'">
              <span :class="[{'error': parseInt(record.free) < record.to_append && !formData.tools_to_add.includes(record.product_id), 'semi-bold': true}]">
                {{ text }}
              </span>
                  </template>

                  <template v-else-if="['free', 'issued'].includes(column.dataIndex)">
              <span class="semi-bold">
                {{ text }}
              </span>
                  </template>
                </template>
              </a-table>
            </div>

            <div v-else class="mobile-table-block">
              <a-collapse
                  v-model:activeKey="activeKeys"
                  :expand-icon="renderExpandIcon"
                  expand-icon-position="start"
              >
                <template #expandIcon="{ isActive }">
                  <PlusOutlined :rotate="isActive ? 45 : 0" />
                </template>
                <a-collapse-panel key="tests" header="Оценка">
                  <div v-for="(record, key) in tableData.tests" :key="key" class="product-card">
                    <div class="mobile-product">
                      <p class="product-header semi-bold">
                        {{ record.product }}
                      </p>

                      <div class="product-mobile-block">
                        <p>
                          Доступно
                        </p>

                        <p class="semi-bold">
                          {{ record.free }}
                        </p>
                      </div>
                      <div class="product-mobile-block">
                        <p>
                          Выдано
                        </p>

                        <p class="semi-bold">
                          {{ record.issued }}
                        </p>
                      </div>
                      <div class="product-mobile-block">
                        <p>
                          К выдаче
                        </p>

                        <p :class="[{'error': parseInt(record.free) < record.to_append && !formData.tests_to_add.includes(record.product_id), 'semi-bold': true}]">
                          {{ record.to_append }}
                        </p>
                      </div>

                      <div class="product-mobile-button-block">
                        <template v-if="!recentlyFinishedTests[record.product_id] || !recentlyFinishedTests[record.product_id].length || formData.tests_to_add.includes(record.product_id)">
                          <a-button class="control-button" :disabled="(parseInt(record.free) < record.to_append && insufficientProducts.tests.some((el) => el.product_id === record.product_id)) || !record.to_append"
                                    @click="() => handleQuota('tests', record, 'add')"
                                    :class="[{'selected': formData.tests_to_add.includes(record.product_id)}]">
                            Выдать
                          </a-button>
                        </template>

                        <template v-else>
                          <a-popconfirm
                              :open="openRowKey === (record.product_id + '_add')"
                              placement="top"
                              :show-cancel="true"
                              :icon="null"
                              ok-text="Выдать"
                              cancel-text="Не выдавать"
                              overlay-class-name="revoke-popconfirm"
                              @confirm="() => handleQuota('tests', record, 'add')"
                          >

                            <template #title>
                              <div class="pc-head">
                                <ExclamationCircleOutlined class="pc-warn-ic" />
                                <div class="pc-text">
                                  <div class="pc-title">
                              <span class="link" @click="() => showProductUsers(record.product_id, 'tests', 'recently_finished')">
                                {{ (recentlyFinishedTests[record.product_id].length + ' ' + getWordFormBasedOnTheCount(recentlyFinishedTests[record.product_id].length, 'сотрудник', 'сотрудника', 'сотрудников')) }}
                              </span>
                                  </div>
                                  <div class="pc-sub">
                                    {{ 'недавно ' +
                                  getWordFormBasedOnTheCount(recentlyFinishedTests[record.product_id].length, 'прошел', 'прошли', 'прошли') + ' тестирование'}}
                                  </div>
                                </div>
                              </div>
                            </template>

                            <template #description>
                              <div class="pc-desc">
                                Мы рекомендуем проходить его не чаще одного раза в полгода, на развитие способностей ЭИ требуется время.
                              </div>
                            </template>

                            <template #cancelButton>
                              <a-button class="secondary-button" @click="openRowKey = null">
                                Не выдавать
                              </a-button>
                            </template>

                            <template #okButton>
                              <a-button class="create-button"
                                        @click="() => handleQuota('tests', record, 'add')"
                              >
                                Выдать
                              </a-button>
                            </template>

                            <a-button :disabled="!record.to_append" class="control-button"  @click="() => {if (!formData.tests_to_add.includes(record.product_id)) handlePopup(record.product_id, 'add')}"
                                      :class="[{'selected': formData.tests_to_add.includes(record.product_id)}]"
                            >
                              Выдать
                            </a-button>
                          </a-popconfirm>
                        </template>

                        <template v-if="record.to_remove === record.issued || formData.tests_to_remove.includes(record.product_id)">
                          <a-button class="control-button" :disabled="!record.to_remove"  @click="() => handleQuota('tests', record, 'remove')" :class="[{'selected': formData.tests_to_remove.includes(record.product_id)}]">
                            Отозвать
                          </a-button>
                        </template>

                        <template v-else>
                          <a-popconfirm
                              :open="openRowKey === (record.product_id + '_remove')"
                              placement="top"
                              :show-cancel="true"
                              :icon="null"
                              ok-text="Отозвать"
                              cancel-text="Отменить"
                              overlay-class-name="revoke-popconfirm"
                              @confirm="() => handleQuota('tests', record, 'remove')"
                          >

                            <template #title>
                              <div class="pc-head">
                                <ExclamationCircleOutlined class="pc-warn-ic" />
                                <div class="pc-text">
                                  <div class="pc-title">Доступ отзовется</div>
                                  <div class="pc-sub">
                              <span class="link" @click="() => showProductUsers(record.product_id, 'tests', 'remove')">
                                {{ buildMessageString('tests', record.product_id, ['сотрудника', 'сотрудников', 'сотрудников']) }}
                              </span>
                                  </div>
                                </div>
                              </div>
                            </template>

                            <template #description>
                              <div class="pc-desc">
                                Некоторые сотрудники уже начали тестирование, поэтому у них нельзя отозвать доступ.
                              </div>
                            </template>

                            <template #cancelButton>
                              <a-button class="secondary-button" @click="openRowKey = null">
                                Отменить
                              </a-button>
                            </template>

                            <template #okButton>
                              <a-button class="create-button"
                                        @click="() => handleQuota('tests', record, 'remove')"
                              >
                                Отозвать
                              </a-button>
                            </template>

                            <a-button :disabled="!record.to_remove" class="control-button"  @click="() => {if (!formData.tests_to_remove.includes(record.product_id)) handlePopup(record.product_id, 'remove')}"
                                      :class="[{'selected': formData.tests_to_remove.includes(record.product_id)}]"
                            >
                              Отозвать
                            </a-button>
                          </a-popconfirm>
                        </template>
                      </div>
                    </div>

                  </div>
                </a-collapse-panel>

                <a-collapse-panel key="courses" header="Развитие">
                  <div v-for="(record, key) in tableData.courses" :key="key" class="product-card">
                    <div class="mobile-product">
                      <p class="product-header semi-bold">
                        {{ record.product }}
                      </p>

                      <div class="product-mobile-block">
                        <p>
                          Доступно
                        </p>

                        <p class="semi-bold">
                          {{ record.free }}
                        </p>
                      </div>
                      <div class="product-mobile-block">
                        <p>
                          Выдано
                        </p>

                        <p class="semi-bold">
                          {{ record.issued }}
                        </p>
                      </div>
                      <div class="product-mobile-block">
                        <p>
                          К выдаче
                        </p>

                        <p :class="[{'error': parseInt(record.free) < record.to_append && !formData.courses_to_add.includes(record.product_id), 'semi-bold': true}]">
                          {{ record.to_append }}
                        </p>
                      </div>

                      <div class="product-mobile-button-block">
                        <a-button :disabled="(parseInt(record.free) < record.to_append && insufficientProducts.courses.some((el) => el.product_id === record.product_id)) || !record.to_append" class="control-button" @click="() => handleQuota('courses', record, 'add')"
                                  :class="[{'selected': formData.courses_to_add.includes(record.product_id)}]"
                        >
                          Выдать
                        </a-button>

                        <template v-if="record.to_remove === record.issued || formData.courses_to_remove.includes(record.product_id)">
                          <a-button :disabled="!record.to_remove" class="control-button"  @click="() => handleQuota('courses', record, 'remove')"
                                    :class="[{'selected': formData.courses_to_remove.includes(record.product_id)}]"
                          >
                            Отозвать
                          </a-button>
                        </template>

                        <template v-else>
                          <a-popconfirm
                              :open="openRowKey === (record.product_id + '_' + 'remove')"
                              placement="top"
                              :show-cancel="true"
                              :icon="null"
                              ok-text="Отозвать"
                              cancel-text="Отменить"
                              overlay-class-name="revoke-popconfirm"
                              @confirm="() => handleQuota('courses', record, 'remove')"
                          >

                            <template #title>
                              <div class="pc-head">
                                <ExclamationCircleOutlined class="pc-warn-ic" />
                                <div class="pc-text">
                                  <div class="pc-title">Доступ отзовется</div>
                                  <div class="pc-sub">
                              <span class="link" @click="() => showProductUsers(record.product_id, 'courses', 'remove')">
                                {{ buildMessageString('courses', record.product_id, ['сотрудника', 'сотрудников', 'сотрудников']) }}
                              </span>
                                  </div>
                                </div>
                              </div>
                            </template>

                            <template #description>
                              <div class="pc-desc">
                                Некоторые сотрудники уже начали курсы, поэтому у них нельзя отозвать доступ.
                              </div>
                            </template>

                            <template #cancelButton>
                              <a-button class="secondary-button" @click="openRowKey = null">
                                Отменить
                              </a-button>
                            </template>

                            <template #okButton>
                              <a-button class="create-button"
                                        @click="() => handleQuota('courses', record, 'remove')"
                              >
                                Отозвать
                              </a-button>
                            </template>

                            <a-button :disabled="!record.to_remove" class="control-button"  @click="() => {if (!formData.courses_to_remove.includes(record.product_id)) handlePopup(record.product_id, 'remove')}"
                                      :class="[{'selected': formData.courses_to_remove.includes(record.product_id)}]"
                            >
                              Отозвать
                            </a-button>
                          </a-popconfirm>
                        </template>
                      </div>
                    </div>

                  </div>
                </a-collapse-panel>

                <a-collapse-panel v-if="tableData.tools" key="tools" header="Ежедневные помощники">
                  <div v-for="(record, key) in tableData.tools" :key="key" class="product-card">
                    <div class="mobile-product">
                      <p class="product-header semi-bold">
                        {{ record.product }}
                      </p>

                      <div class="product-mobile-block">
                        <p>
                          Доступно
                        </p>

                        <p class="semi-bold">
                          {{ record.free }}
                        </p>
                      </div>
                      <div class="product-mobile-block">
                        <p>
                          Выдано
                        </p>

                        <p class="semi-bold">
                          {{ record.issued }}
                        </p>
                      </div>
                      <div class="product-mobile-block">
                        <p>
                          К выдаче
                        </p>

                        <p :class="[{'error': parseInt(record.free) < record.to_append && !formData.tools_to_add.includes(record.product_id), 'semi-bold': true}]">
                          {{ record.to_append }}
                        </p>
                      </div>

                      <div class="product-mobile-button-block">
                        <a-button :disabled="(parseInt(record.free) < record.to_append && insufficientProducts.courses.some((el) => el.product_id === record.product_id)) || !record.to_append" class="control-button" @click="() => handleQuota('tools', record, 'add')"
                                  :class="[{'selected': formData.tools_to_add.includes(record.product_id)}]"
                        >
                          Выдать
                        </a-button>

                        <a-button :disabled="!record.to_remove" class="control-button"  @click="() => handleQuota('tools', record, 'remove')"
                                  :class="[{'selected': formData.tools_to_remove.includes(record.product_id)}]"
                        >
                          Отозвать
                        </a-button>

                      </div>
                    </div>

                  </div>
                </a-collapse-panel>
              </a-collapse>

            </div>
          </div>

          <div class="loading-block" v-else>
            <a-spin />
          </div>
        </div>

        <a-divider style="margin: 16px 0" />
        <div class="modal-no-padding__footer">
          <div class="button-row-full">
            <div>
              <a-button class="secondary-button" @click="showOrderForm">Заказать доступы</a-button>
            </div>
            <div class="small-button-row">
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
              <a-button :loading="managingInProcess" class="primary-button" @click="handleQuotas">Применить</a-button>
            </div>
          </div>

          <div class="button-row-mobile">
            <div>
              <a-button :loading="managingInProcess" class="primary-button" @click="handleQuotas">Применить</a-button>
            </div>
            <div class="small-button-row">
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
              <a-button class="secondary-button" @click="showOrderForm">Заказать доступы</a-button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
</template>

<script>
import {onBeforeMount, reactive, ref} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import {InfoCircleFilled, PlusOutlined, ExclamationCircleOutlined, MinusOutlined, UpOutlined, DownOutlined} from "@ant-design/icons-vue";
import {h, onMounted} from "vue";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import {getWordFormBasedOnTheCount} from "@/views/Report/utils";
import getReportName from "@/mixins/getReportName";
import { message } from 'ant-design-vue';
import tools from "@/mixins/dictionaries/toolsTranslate";
import {Divider} from "ant-design-vue";

export default {
  methods: {getWordFormBasedOnTheCount},
    components: {
      InfoCircleFilled,
      ExclamationCircleOutlined,
      PlusOutlined,
      UpOutlined,
      DownOutlined,
    },
    emits: ['close', 'showStaff', 'showOrderForm', 'submitted'],
    props: {
      name: String,
      userData: Array,
      mode: String,
      open: Boolean,
    },
    setup(props, context) {

      const store = useStore();

      const sendInvite = ref(true);
      const allowViewReport = ref(false);
      const showInstruction = ref(false);
      const quotasLoaded = ref(true);
      const managingInProcess = ref(false);

      const companyQuotas = computed(() => store.state.company.userQuotas);
      const selectedStaffQuotas = computed(() => store.state.company.staffQuotas);

      const openRowKey = ref(null);

      const insufficientProducts = reactive({
        courses: [],
        tests: [],
      });

      const tableData = reactive({
        courses: null,
        tests: null,
        tools: null,
      });

      const formData = reactive({
        users: props.userData,
        courses_to_add: [],
        courses_to_remove: [],
        tests_to_add: [],
        tests_to_remove: [],
        tools_to_add: [],
        tools_to_remove: [],
      });

      onBeforeMount(() => {
        quotasLoaded.value = false;

        store.dispatch('company/getUserQuotas').then(() => {
          store.dispatch('company/getStaffQuotas', props.userData).
              then(() => {
                prepareTableData();
                quotasLoaded.value = true;
          });
        });
      });

      const prepareTableData = () => {
        tableData.tests = Object.entries(companyQuotas.value.test_passings)
            .filter(([key]) => key !== 'empty')
            .map(([key, value]) => {

              let quotasToAppend = calculateQuotasToAppend('tests', key);
              let issuedPassings = calculateIssuedPassings('tests', key);

              if (quotasToAppend > value.free) {
                insufficientProducts.tests.push({
                  product_id: key,
                  count: quotasToAppend - value.free,
                });
              }

              return {
                product: getReportName(key),
                product_id: key,
                free: value.free,
                issued: issuedPassings,
                to_append: quotasToAppend,
                to_remove: calculateQuotasToRemove('tests', key),
                original_free: value.free,
                original_issued: issuedPassings,
              }
            });

        tableData.courses = Object.entries(companyQuotas.value.course_passings.total).map(([key, value]) => {
          let freePassings = companyQuotas.value.course_passings.free.find((course) => course.course_id === value.course_id);

          let quotasToAppend = calculateQuotasToAppend('courses', value.course_id);
          let quotasIssued = calculateIssuedPassings('courses', value.course_id);

          if (quotasToAppend > (freePassings?.count ?? 0)) {
            insufficientProducts.courses.push({
              product_id: value.course_id,
              count: quotasToAppend - (freePassings?.count ?? 0),
            });
          }

          return {
            product: value.name,
            product_id: value.course_id,
            free: freePassings?.count ?? 0,
            issued: quotasIssued,
            to_append: quotasToAppend,
            to_remove: calculateQuotasToRemove('courses', value.course_id),
            original_free: freePassings?.count ?? 0,
            original_issued: quotasIssued,
          }
        });

        if (companyQuotas.value.instruments?.allowed_instruments) {
          tableData.tools = companyQuotas.value.instruments.allowed_instruments.map((instrument) => {

            let quotasToAppend = calculateQuotasToAppend('tools', instrument);
            let quotasToRemove = calculateQuotasToRemove('tools', instrument);

            return {
              product: tools[instrument] ?? '',
              product_id: instrument,
              free: quotasToAppend,
              issued: quotasToRemove,
              to_append: (quotasToAppend - quotasToRemove) ?? 0,
              to_remove: quotasToRemove,
              original_free: quotasToAppend,
              original_issued: quotasToRemove,
            }
          })
        }

        prepareAdditionalData();
      }

      const activeStatuses = ['new', 'in_progress', 'questionnaire', 'expired', 'instruction'];
      const removableStatuses = ['new'];

      const usersWithNoQuotaToRemove = reactive({
        tests: {
          empty: [],
          standard: [],
          full: [],
          management: [],
        },
        courses: {},
      });

      const usersWithQuotaToRemove = reactive({
        tests: {
          empty: [],
          standard: [],
          full: [],
          management: [],
        },
        courses: {},
      });

      const recentlyFinishedTests = reactive({
        standard: [],
        full: [],
        management: [],
      });

      const calculateQuotasToAppend = (key, product) => {
        let numberToAppend = 0;

        selectedStaffQuotas.value.map((user) => {
          let userHasActiveProduct = false;

          if (key === 'tests') {
            userHasActiveProduct = user.tests.find((el) => (el.report_type === product && activeStatuses.includes(el.status)) || activeStatuses.includes(el.status));
          } else if (key === 'courses') {
            userHasActiveProduct = user.courses.find((el) =>  parseInt(el.course_id) === parseInt(product) && activeStatuses.includes(el.status));
          } else if (key === 'tools') {
            userHasActiveProduct = user.instruments[product] ? 1 : 0;
          }

          if (!userHasActiveProduct) numberToAppend++;
        });

        return numberToAppend;
      }

      const calculateQuotasToRemove = (key, product) => {
        let numberToRemove = 0;

        selectedStaffQuotas.value.map((user) => {
          let removableProducts = 0;

          if (key === 'tests') {
            removableProducts = user.tests.filter((el) => el.report_type === product && removableStatuses.includes(el.status))?.length ?? 0;
          } else if (key === 'courses') {
            removableProducts = user.courses.filter((el) => parseInt(el.course_id) === parseInt(product) && removableStatuses.includes(el.status))?.length ?? 0;
          } else if (key === 'tools') {
            removableProducts = user.instruments[product] ? 1 : 0;
          }

          numberToRemove += removableProducts;
        });

        return numberToRemove;
      }

      const prepareAdditionalData = () => {
        selectedStaffQuotas.value.map((user) => {

          user.courses.map((el) => {
            if (el.status !== 'new') {
              let current = usersWithNoQuotaToRemove.courses[el.course_id] ?? [];

              if (!current.includes(user.id)) {
                current.push(user.id);
                usersWithNoQuotaToRemove.courses[el.course_id] = current;
              }
            } else {
              let current = usersWithQuotaToRemove.courses[el.course_id] ?? [];

              if (!current.includes(user.id)) {
                current.push(user.id);
                usersWithQuotaToRemove.courses[el.course_id] = current;
              }
            }
          });

          user.tests.map((el) => {
            if (el.status !== 'new') {
              let current = usersWithNoQuotaToRemove.tests[el.report_type] ?? [];

              if (!current.includes(user.id)) {
                current.push(user.id);
                usersWithNoQuotaToRemove.tests[el.report_type] = current;
              }
            } else {
              let current = usersWithQuotaToRemove.tests[el.report_type] ?? [];

              if (!current.includes(user.id)) {
                current.push(user.id);
                usersWithQuotaToRemove.tests[el.report_type] = current;
              }
            }

            if (el.recently_finished) {
              let current = recentlyFinishedTests[el.report_type] ?? [];

              if (!current.includes(user.id)) {
                current.push(user.id);
                recentlyFinishedTests[el.report_type] = current;
              }
            }
          })
        });
      }

      const calculateIssuedPassings = (type, product) => {
        let productCount = 0;

        selectedStaffQuotas.value.map((user) => {
          let products = false;

          if (type === 'tests') {
            products = user.tests.filter((el) => el.report_type === product)?.length ?? 0;
          } else if (type === 'courses') {
            products = user.courses.filter((el) => parseInt(el.course_id) === parseInt(product))?.length ?? 0;
          }

          productCount += products;
        });

        return productCount;
      }

      const handleQuota = (type, product, action) => {
         openRowKey.value = null;
         let label = type + '_to_' + action;

         // отменить то же действие
         if (formData[label].includes(product.product_id)) {
           formData[label] = formData[label].filter((el) => el !== product.product_id);

           recalculateRemainingQuotas(product.product_id, type, action, true);
           return;
         }

         // добавить действие
         formData[label].push(product.product_id);

         // убрать противоположное действие
         let labelToFiler = type + '_to_' + (action === 'add' ? 'remove' : 'add');
         formData[labelToFiler] = formData[labelToFiler].filter((el) => el !== product.product_id);

         recalculateRemainingQuotas(product.product_id, type, action, false);
      }

      const recalculateRemainingQuotas = (product, type, action, restore = false) => {
        tableData[type].map((el) => {
          if (el.product_id === product) {

            if (action === 'add') {
                if (restore) {
                  el.free = el.original_free;
                  el.issued = el.original_issued;
                } else {
                  el.free = el.original_free - el.to_append;
                  el.issued = el.original_issued + el.to_append;
                }
            } else {
              if (restore) {
                el.free = el.original_free;
                el.issued = el.original_issued;
              } else {
                el.free = el.original_free + el.to_remove;
                el.issued = el.original_issued - el.to_remove;
              }
            }
          }
        });
      }

      const expandedMap = ref({
        tests: true,
        courses: true,
        tools: false,
      });

      const renderedMap = ref({
        tests: true,
        courses: true,
        tools: false,
      });

      const toggleTable = (key) => {
        if (expandedMap.value[key]) {
          expandedMap.value[key] = false;

          setTimeout(() => {
            if (!expandedMap.value[key]) {
              renderedMap.value[key] = false;
            }
          }, 120);
        } else {
          renderedMap.value[key] = true;

          requestAnimationFrame(() => {
            expandedMap.value[key] = true;
          });
        }
      };

      const activeKeys = ref(['tests', 'courses']);

      const emptySlot = () =>
          h('div', { class: 'no-data-wrapper' }, [
            h('img', { src: NotFoundIcon, class: 'no-data-image'}),
            h('div', {class: 'no-data-text'}, 'Нет данных для отображения'),
          ]);

      const renderCollapseElement = (key) =>
          h(
              "span",
              {
                class: [
                  "custom-collapse-expand-icon",
                  expandedMap.value[key] ? "custom-collapse-expand-icon--active" : "",
                ],
                onClick: (e) => {
                  e.stopPropagation();
                  toggleTable(key);
                },
              },
              [
                h(expandedMap.value[key] ? MinusOutlined : PlusOutlined),
              ]
          );

      const getExtendedColumns = (key, mainTitle) => {
        return [
          {
            title: () => renderCollapseElement(key),
            dataIndex: 'toggle',
            key: 'toggle',
            width: 25,
            align: 'center',
          },
          {
            title: mainTitle,
            dataIndex: 'product',
            key: 'product',
            width: 130,
            align: 'left',
          },
          {
            title: 'Доступно',
            dataIndex: 'free',
            key: 'free',
            width: 50,
            align: 'right',
          },
          {
            title: 'Выдано',
            dataIndex: 'issued',
            key: 'issued',
            width: 50,
            align: 'right',
          },
          {
            title: 'К выдаче',
            dataIndex: 'to_append',
            key: 'to_append',
            width: 50,
            align: 'right',
          },
          {
            title: 'Доступ',
            dataIndex: 'control',
            key: 'control',
            width: 100,
            align: 'right',
          },
        ];
      }

      const getTableComponents = (tableKey) => ({
        body: {
          wrapper: (props, { slots }) =>
              h(
                  'tbody',
                  {
                    ...props,
                    class: [
                      props.class,
                      'table-collapse-body',
                      {
                        'table-collapse-body--open': renderedMap.value[tableKey] && expandedMap.value[tableKey],
                        'table-collapse-body--closing': renderedMap.value[tableKey] && !expandedMap.value[tableKey],
                        'table-collapse-body--hidden': !renderedMap.value[tableKey],
                      },
                    ],
                  },
                  slots.default?.()
              ),
        },
      });

      const closeForm = () => {
        store.dispatch('company/clearStaffQuotas');
        context.emit('close');
      }

      const handlePopup = (id, action) => {
        openRowKey.value =`${id}_${action}`;
      }

      const showProductUsers = (product, productType = null, type = null) => {
        let staff = null;

        if (product === 'all') {
          staff = props.userData;
        } else if (type === 'recently_finished') {
          staff = recentlyFinishedTests[product];
        } else if (product !== 'empty') {
          staff = usersWithQuotaToRemove[productType][product];
        }

        store.dispatch('users/setSpecialStaff', staff).then(() => {
          context.emit('showStaff');
        });
      }

      const handleQuotas = () => {
        managingInProcess.value = true;

        store.dispatch('company/manageQuotas', {
          allow_view_report: allowViewReport.value,
          notify: sendInvite.value,
          ...formData,
        }).then(() => {
          message.success('Данные сохранены');
          context.emit('submitted');
        }).catch((e) => {
          message.error('Произошла ошибка');
        }).finally(() => {
          managingInProcess.value = false;
        });
      }

      const showOrderForm = () => {
        store.dispatch('relations/setInsufficientProducts', insufficientProducts).then(() => {
          context.emit('showOrderForm');
        });
      }

      const buildMessageString = (type, product, stringVariations) => {
        let totalNumberOfUsersWithQuota = (usersWithNoQuotaToRemove[type][product]?.length ?? 0) +
            (usersWithQuotaToRemove[type][product]?.length ?? 0);

        return 'У ' + usersWithQuotaToRemove[type][product]?.length + ' из ' +
            (totalNumberOfUsersWithQuota +
                ' ' + getWordFormBasedOnTheCount(totalNumberOfUsersWithQuota, ...stringVariations))
      }

      const isMobile = ref(window.innerWidth <= 768)

      const onResize = () => {
        isMobile.value = window.innerWidth <= 768
      }

      const modalMobileStyleObject = computed(() => ({
        position: 'relative',
        bottom: '0',
        top: 'unset',
        marginBottom: '0',
        paddingBottom: '0',
        width: '100vw',
        minWidth: '100vw',
      }));

      onMounted(() => {
        window.addEventListener('resize', onResize)
      });

      const renderExpandIcon = ({ isActive }) => {
        const Icon = isActive ? MinusOutlined : PlusOutlined;
        return h(
            "span",
            { class: "custom-collapse-expand-wrap" },
            [
              h(Icon, {
                class: [
                  "custom-collapse-expand-icon",
                  isActive ? "custom-collapse-expand-icon--active" : "",
                ],
              }),
              h(Divider, { type: "vertical", class: "custom-collapse-divider" }),
            ]
        );
      };

      return {
        sendInvite,
        allowViewReport,
        showInstruction,
        emptySlot,
        expandedMap,
        getExtendedColumns,
        getTableComponents,
        tableData,
        closeForm,
        quotasLoaded,
        handleQuota,
        formData,
        managingInProcess,
        insufficientProducts,
        openRowKey,
        showProductUsers,
        usersWithNoQuotaToRemove,
        usersWithQuotaToRemove,
        recentlyFinishedTests,
        handlePopup,
        handleQuotas,
        showOrderForm,
        isMobile,
        activeKeys,
        buildMessageString,
        modalMobileStyleObject,
        renderExpandIcon
      }
    }
  }
</script>

<style scoped lang="scss">
  .bg-block, .border-block {
    border-radius: 8px;
    padding: 10px 15px;
  }

  .bg-block {
    background-color: var(--neutral-grey);
  }

  .border-block {
    border: 1px solid var(--neutral-grey);
  }

  .link {
    color: var(--primary-link-green);
    cursor: pointer;
  }

  .link:hover {
    color: var(--main-green);
  }

  .group-block {
    margin-bottom: 15px;
    font-size: 16px;
  }

  .access-switch-block {
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
  }

  .access-switch {
    display: flex;
    column-gap: 12px;
    align-items: center;
  }

  .create-button:not(:disabled) {
    background-color: var(--main-green);
    color: #fff;
  }

  .create-button:not(:disabled):hover {
    background-color: var(--main-green);
    border-color: var(--polar-green-6);
    color: #fff;
  }

  .create-button:active {
    background-color: var(--main-green);
    border-color: var(--polar-green-6);
    color: #fff;
  }

  .cancel-button:hover,
  .cancel-button:active {
    color: var(--dist-red-main);
    border-color: var(--dist-red-main);
  }

  .order-button:hover, .order-button:focus {
    border-color: var(--main-green);
    color: var(--main-font);
  }

  p {
    margin-bottom: 0;
  }

  ul {
    margin-top: 5px;
    padding-left: 20px;
  }

  ul li {
    list-style: initial;
  }

  .alert-block {
    margin-bottom: 15px;
  }

  :deep(.ant-table-content) {
    min-height: auto !important;
  }

  .table-block {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    row-gap: 15px;

    @media (max-width: $mobile-breakpoint) {
      display: none;
    }

    :deep(.ant-table-cell) {
      border-bottom: unset;
    }

    :deep(table>thead>tr:first-child >*:last-child) {
      border-start-end-radius: 8px;
      border-end-end-radius: 8px;
    }

    :deep(table>thead>tr:first-child >*:first-child) {
      border-start-start-radius: 8px;
      border-bottom-left-radius: 8px;
    }
  }

  .mobile-table-block {
    display: none;
    margin-top: 15px;

    @media (max-width: $mobile-breakpoint) {
      display: block;
    }
  }

  .button-row-mobile {
    display: none;

    @media (max-width: $mobile-breakpoint) {
      display: flex;
      flex-direction: column;
      row-gap: 5px;
    }

    button {
      width: 100%;
    }
  }

  .button-row-full {
    display: flex;
    column-gap: 10px;
    row-gap: 15px;
    justify-content: space-between;

    @media (max-width: $mobile-breakpoint) {
      display: none;
    }
  }

  .small-button-row {
    display: flex;
    column-gap: 10px;
  }

  .control-button-wrapper {
    display: flex;
    column-gap: 5px;
    justify-content: end;
  }

  .control-button:not(:disabled) {
    padding: 4px 9px;
    color: var(--main-green);
    border: 1px solid var(--main-green);
  }

  .control-button:not(:disabled):hover {
    border-color: var(--hover-green);
    color: var(--hover-green);
  }

  .control-button:not(:disabled):active,
  .control-button:not(:disabled):focus {
    border-color: var(--active-green);
    color: var(--active-green);
  }

  .control-button:disabled {
    padding: 4px 9px;
    background-color: #FFFFFF;
  }

  .error {
    font-weight: 500;
    color: var(--dist-red-main);
  }

  .control-button.selected:not(:disabled) {
    color: #FFFFFF !important;
    background-color: var(--main-green);
  }

  .control-button.selected:not(:disabled):hover {
    color: #FFFFFF !important;
    background-color: var(--hover-green);
  }

  .pc-head {
    display: flex;
    gap: 20px;
    align-items: flex-start;
  }

  .pc-warn-ic {
    margin-top: 2px;
    font-size: 25px;
    color: #faad14;
  }

  .pc-title {
    font-weight: 700;
  }

  .pc-sub {
    margin-top: 2px;
  }

  .pc-desc {
    margin-top: 8px;
  }

  :deep(.ant-collapse-content-box) {
    padding: 0 !important;
  }

  .product-header {
    margin-bottom: 10px;
  }

  .product-mobile-block {
    display: flex;
    justify-content: space-between;
  }

  .product-card:not(:last-child) {
    border-bottom: 1px solid var(--border-grey);
  }

  .mobile-product {
    padding: 16px;
  }

  .product-mobile-button-block {
    margin-top: 10px;
    display: flex;
    column-gap: 15px;
  }

  .product-mobile-button-block button,
  .product-mobile-button-block button:disabled,
  :deep(.product-mobile-button-block .ant-popover-disabled-compatible-wrapper){
    width: 100%;
    justify-content: center;
  }

  h2 {
    margin: 0;
  }

  :deep(.ant-collapse-header) {
    padding: 0 0 5px !important;
    font-weight: 500;
  }

  :deep(.custom-collapse-expand-icon) {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    background: #fff;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, transform 0.2s;
    color: var(--main-font);
  }

  :deep(.custom-collapse-expand-icon--active) {
    transform: translateY(1px);
  }

  :deep(.ant-table-thead>tr>th) {
    padding: 5px !important;
  }

  :deep(.ant-table-thead>tr>th:not(:first-child)) {
    padding: 5px !important;
  }

  @media (max-width: $mobile-breakpoint) {
    :deep(.ant-collapse-expand-icon) {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 5px;
      padding-left: 5px;
      padding-inline-end: 0;
    }

    :deep(.ant-collapse-header) {
      padding: 5px 0 !important;
    }
  }
</style>